var path = 'components/widgets-bundle-select.tpl.html';
var html = "\n<md-select ng-required=\"tbRequired\" ng-model=\"widgetsBundle\" md-container-class=\"tb-widgets-bundle-select\" placeholder=\"{{ 'widget.select-widgets-bundle' | translate }}\" class=\"md-no-underline\">\n    <md-option ng-repeat=\"item in widgetsBundles\" ng-value=\"item\">\n        <div class=\"tb-bundle-item\">\n            <span>{{item.title}}</span>\n            <span translate class=\"tb-bundle-system\" ng-if=\"isSystem(item)\">widgets-bundle.system</span>\n        </div>\n    </md-option>\n</md-select>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/widgets-bundle-select.tpl.html
// module id = 1424
// module chunks = 1